var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.582 36.023l9.082-8.686c-1.887-7.356-9.379-11.79-16.735-9.904a13.75 13.75 0 0 0-8.07 5.76c.14-.003 15.723 12.829 15.723 12.829z",
    fill: "#0364b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.778 24.829v.002c-1.735-1.075-3.737-1.643-5.778-1.64l-.141.004a11 11 0 0 0-10.858 11.13c.027 2.203.715 4.346 1.975 6.153l13.606-1.704 10.432-8.412-9.237-5.532z",
    fill: "#0078d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.664 27.338l-.603-.023c-1.219-.001-2.424.248-3.543.731v-.001l-5.504 2.316 6.068 7.495 10.847 2.637a8.94 8.94 0 0 0-7.265-13.155h0z",
    fill: "#1490df"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.976 40.477c2.054 2.954 5.425 4.714 9.023 4.712h24.062c3.287.001 6.309-1.803 7.868-4.696L35.015 30.361 10.976 40.477z",
    fill: "#28a8ea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDrive);
export default __webpack_public_path__ + "static/media/one-drive.9d9312498404350be3c443edb3cc79de.svg";
export { ForwardRef as ReactComponent };